// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"454585e1","154":"79a81520","544":"2f5a0636","842":"94bd08de","973":"242e210f"}[chunkId] + ".chunk.js";
};